import { render } from "./BuiltinLoginForm.vue?vue&type=template&id=1eb95ee9&scoped=true&ts=true"
import script from "./BuiltinLoginForm.vue?vue&type=script&lang=ts"
export * from "./BuiltinLoginForm.vue?vue&type=script&lang=ts"

import "./BuiltinLoginForm.vue?vue&type=style&index=0&id=1eb95ee9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb95ee9"]])

export default __exports__